import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _get from "lodash/get";

import TermsBulkUpload from "./TermsBulkUpload";
import propTypes from "../../../../../../constants/propTypes";
import {
  performImportRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { closeModalDialog } from "../../../../../../actions/layoutActions";
import { processImportRequestStatus } from "../../../../../../utils/dataComponentUtils";
import * as REQUEST_TYPES from "../../../../../../constants/RequestTypes";
import FormikForm from "../../../../../forms/FormikForm";

export const processRequestStatus = (
  prevDataComponent,
  dataComponent,
  { closeModalDialog, setReload, setErrorMessage }
) => {
  processImportRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponent.dataComponentId, true);
    },
    onError: ({ response, data }) => {
      if (response.status === -1) {
        return setErrorMessage("Failed request");
      }
      const message =
        _get(data, "errors[0].detail") ||
        _get(data, "errors[0].title") ||
        "There was an error importing the file.";
      setErrorMessage(message);
    },
  });
};

const TermsBulkUploadContainer = ({
  closeModalDialog,
  performImportRequest,
  setReload,
  dataComponent,
  dataComponentId,
  loading,
  pluralEntity,
  additionalValues,
}) => {
  const [prevDataComponent, setDataComponent] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    setDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestStatus(prevDataComponent, dataComponent, {
      closeModalDialog,
      setReload,
      setErrorMessage,
    });
  }, [
    prevDataComponent,
    dataComponent,
    setReload,
    closeModalDialog,
    setErrorMessage,
  ]);

  const handleUploadFile = useCallback(
    ({ file }) => {
      setErrorMessage(null);
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("additionalValues", JSON.stringify(additionalValues));
      performImportRequest(dataComponentId, formData);
    },
    [dataComponentId, performImportRequest, additionalValues]
  );

  return (
    <FormikForm initialValues={{ file: undefined }} onSubmit={handleUploadFile}>
      {({ handleSubmit, values }) => (
        <TermsBulkUpload
          onSubmit={handleSubmit}
          loading={loading}
          pluralEntity={pluralEntity}
          file={values.file}
          errorMessage={errorMessage}
        />
      )}
    </FormikForm>
  );
};

TermsBulkUploadContainer.propTypes = {
  closeModalDialog: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  performImportRequest: PropTypes.func.isRequired,
  dataComponentId: PropTypes.string.isRequired,
  dataComponent: propTypes.dataComponent,
  additionalValues: PropTypes.shape({}),
  loading: PropTypes.bool,
  pluralEntity: PropTypes.string.isRequired,
};

const mapStateToProps = (state, { dataComponentId }) => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
    loading: _get(
      dataComponent,
      `requestState.${REQUEST_TYPES.IMPORT}.loading`
    ),
  };
};

const mapDispatchToProps = {
  performImportRequest,
  closeModalDialog,
  setReload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsBulkUploadContainer);
